import React from "react";

interface LogoProps {
  src?: string;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({
  src = "https://mylighthouse.co/assets/images/lighthouse.png",
}) => (
  <div className="mb-6 text-center">
    <img
      src={src}
      alt="Logo"
      className="inline-block max-h-[200px] max-w-[300px]"
    />
  </div>
);

export default Logo;
